module.exports = {
  joinUnlessMissingOrSame: function (str1, str2) {
    if (!(str1 && str2)) { return str1 || str2 || '' }
    if (str1 !== str2) { return `${str1} - ${str2}` }
    return str1
  },
}

